import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link, Typography } from "@mui/material";
import { MouseEvent, ReactElement } from "react";

import useRole from "../../../../core/routing/useRole";
import { ScopeRole } from "../../../../utils/types/user.type";
import { useDocumentsContext } from "../../hooks";
import {
  DocumentsBreadcrumbs as StyledBreadcrumbs,
  DocumentsLastBreadcrumbsTypography,
} from "./DocumentsBreadcrumbs.styles";

const pageTitle: string = "Documents";

function DocumentsBreadcrumbs(): ReactElement {
  const { state, changeFolder, resetOnChange, resetSelectedFiles, openDocument, resetFiltersSelection } = useDocumentsContext();

  const {
    hasRole: isClientAdmin,
  } = useRole([ScopeRole.ARK_CLIENT_ADMIN]);

  const {
    hasRole: isSuperAdmin,
  } = useRole([ScopeRole.SUPER_ADMIN]);

  const {
    hasRole: isBasicAdmin,
  } = useRole([ScopeRole.BASIC_ADMIN]);

  const handleOnLinkClicked = (
    event: MouseEvent<HTMLAnchorElement>,
    value: number,
    id?: string,
  ) => {
    event.preventDefault();
    changeFolder(value, !!isClientAdmin || !!isSuperAdmin || !!isBasicAdmin);
    resetOnChange();
    resetSelectedFiles();
    openDocument(id || "");
    resetFiltersSelection(true, 1);
  };

  const getLinks = (): ReactElement[] => {
    if (!state) return [];
    let node = state.documents;
    const totalDepth = state.cursor.length;
    const lastIndex = totalDepth - 1;
    const applyLinkTillDepth = lastIndex;
    const items: ReactElement[] = [];

    for (let i = 0; i < applyLinkTillDepth; i++) {
      const value = state.cursor[i];
      const currentFolderDepth = i + 1;

      node = node?.folders?.find(folder => folder.id === value);
      if (node) {
        const nodeName = node.name;
        const nodeId = node.id || "";

        items.push(
          <Link
            underline="hover"
            key={node.id}
            href="#"
            onClick={(e: MouseEvent<HTMLAnchorElement>) => {
              handleOnLinkClicked(e, currentFolderDepth, nodeId);
            }}
          >
            {node.name}
          </Link>
        );
      }
    }

    const currentFolderId = state.cursor[lastIndex];

    node = node?.folders?.find(folder => folder.id === currentFolderId);
    if (node) {
      items.push(
        <DocumentsLastBreadcrumbsTypography key={node.id}>
          {node.name}
        </DocumentsLastBreadcrumbsTypography>
      );
    }
    return items;
  };

  if (state && state.cursor && state.cursor.length > 0) {
    return (
      <StyledBreadcrumbs
        separator={<NavigateNextIcon fontSize="large" />}
        maxItems={3}
        aria-label="documents breadcrumb"
      >
        <Link
          key="documentRoot"
          underline="hover"
          href=""
          onClick={(e: MouseEvent<HTMLAnchorElement>) =>
            handleOnLinkClicked(e, 0)
          }
        >
          {pageTitle}
        </Link>
        {getLinks()}
      </StyledBreadcrumbs>
    );
  }
  return <Typography variant="pageTitle">{pageTitle}</Typography>;
}

export default DocumentsBreadcrumbs;
